import { Injectable } from '@angular/core';
import { OrganisationUI } from '@src/models';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class OrganisationInfoStoreService extends BaseStoreService<OrganisationUI> {}
